import { useAppDispatch, useAppSelector } from '../app/hooks';
import { selectTheme, themeChanged } from '../features/ui/uiSlice';

/** Dark/light switch for the whole app, including the editor. */
export function ThemeSwitch() {
  const theme = useAppSelector(selectTheme);
  const dispatch = useAppDispatch();
  return (
    <label>
      <input
        type="checkbox"
        role="switch"
        checked={theme === 'dark'}
        onChange={(event) => dispatch(themeChanged(event.target.checked ? 'dark' : 'light'))}
      />
      Dark mode
    </label>
  );
}
